import { defineMessages } from 'react-intl';

/**
 * New strings for the Sage search bar (2026-09-28): the two slot eyebrows. Everything else on the
 * bar reuses an existing id: the placeholder (nav.search.placeholder), "jobs" and the go
 * button's label (searchPanel.jobsSuffix / searchPanel.showJobsButton), the Where chip's empty
 * value (search.refinements.locationAnywhere) and the filters chip's label
 * (search.refinements.advancedFilters.aria).
 */
export const searchBarMessages = defineMessages({
  whatLabel: {
    id: 'nav.search.whatLabel',
    defaultMessage: 'What',
    description: 'Navbar search bar: small label above the search text slot (job title, skill or company), like Indeed\'s "What" field',
  },
  whereLabel: {
    id: 'nav.search.whereLabel',
    defaultMessage: 'Where',
    description: 'Navbar search bar: small label above the location chip, like Indeed\'s "Where" field',
  },
});
